var _g, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockForward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    stroke: "#449FDB",
    opacity: ""
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.088 28.5c22.084 0 40 17.912 40 40 0 22.084-17.916 40-40 40-22.092 0-40-17.916-40-40 0-22.088 17.908-40 40-40zM47.088 23.5c-24.812 0-45 20.184-45 45s20.188 45 45 45c24.812 0 45-20.184 45-45s-20.188-45-45-45v0z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.084 70.5c-1.1 0-2-0.9-2-2 0-31.984-26.020-58-58-58-1.104 0-2-0.896-2-2s0.896-2 2-2c34.184 0 62 27.812 62 62 0 1.1-0.892 2-2 2z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.084 71.752c-0.608 0-1.184-0.272-1.568-0.752l-12.964-16.252c-0.688-0.864-0.548-2.124 0.316-2.808 0.872-0.692 2.12-0.552 2.812 0.312l10.956 13.74 7.46-15.916c0.468-1 1.656-1.432 2.664-0.96 1 0.468 1.424 1.66 0.956 2.66l-8.832 18.832c-0.288 0.62-0.892 1.056-1.58 1.132-0.064 0.012-0.148 0.012-0.22 0.012z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.088 70.5c-0.512 0-1.024-0.196-1.416-0.584-0.78-0.78-0.78-2.048 0-2.828l20-20c0.78-0.78 2.048-0.78 2.828 0s0.78 2.044 0 2.828l-20 20c-0.388 0.388-0.9 0.584-1.412 0.584z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.088 70.5c-0.512 0-1.024-0.196-1.416-0.584l-15-15c-0.78-0.784-0.78-2.048 0-2.828s2.048-0.78 2.828 0l15 15c0.78 0.78 0.78 2.048 0 2.828-0.388 0.388-0.9 0.584-1.412 0.584z",
    fill: "#000000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockForward);
export default __webpack_public_path__ + "static/media/Clock-Forward.f95f23d9.svg";
export { ForwardRef as ReactComponent };